export default {
  id: 16,
  title: 'Target #16 - Eye of the Tiger',
  url: 'https://cssbattle.dev/play/16',
  colors: ['#0B2429', '#998235', '#F3AC3C'],
  solution:
    '<a a><a b><a c><style>body,a[c]{background:#0B2429 }a{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%) }a[a]{background:#998235;width:200;height:200;transform:translate(-50%,-50%)rotate(45deg);border-radius: 100px 0;}a[b],a[c]{border-radius:50%;}a[b]{background:#F3AC3C;border:20px solid #0B2429;width:140;height:140;}a[c]{width:50;height:50;}</style>',
}
